import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="bg-white py-24 px-4 sm:px-6 lg:px-8" data-id="element-109">
      <div className="max-w-3xl mx-auto text-center" data-id="element-110">
        <div className="bg-volley-teal/10 text-volley-teal-dark font-semibold text-xs px-4 py-1.5 rounded-full mb-6 inline-block uppercase tracking-[0.2em]" data-id="element-111">
          IL TUO INVESTIMENTO È PROTETTO AL 100%
        </div>
        <h2 className="font-display text-3xl sm:text-4xl md:text-5xl font-medium text-volley-dark leading-tight mb-10 tracking-tight" data-id="element-112">
          Garanzia Totale di{' '}
          <span className="italic text-volley-teal" data-id="element-113">7 Giorni</span>
        </h2>

        <div className="bg-volley-paper rounded-3xl p-8 sm:p-12 shadow-lg border border-volley-navy/5 relative" data-id="element-114">
          <div className="absolute -top-10 left-1/2 -translate-x-1/2 bg-gradient-to-br from-volley-teal to-volley-teal-dark w-20 h-20 rounded-full flex items-center justify-center shadow-xl border-4 border-white" data-id="element-115">
            <ShieldCheck className="w-10 h-10 text-white" data-id="element-116" />
          </div>

          <h3 className="font-display text-2xl font-semibold text-volley-navy mt-6 mb-4" data-id="element-117">
            I tuoi soldi sono protetti al 100%
          </h3>
          <p className="text-volley-slate text-base sm:text-lg leading-relaxed" data-id="element-118">
            Hai 7 giorni interi per esplorare le 6 guide e applicare gli
            esercizi in palestra. Se non sarai pienamente soddisfatto, ti
            rimborseremo il 100% dei tuoi soldi. Zero rischi per te, impegno
            totale da parte nostra.
          </p>
        </div>
      </div>
    </section>;
}